import React, { memo } from "react";
import {
  View,
  Text,
  StyleSheet,
  Pressable,
  Image,
  Platform,
} from "react-native";
import { useNavigation } from "@react-navigation/native";
import Animated, { FadeInDown } from "react-native-reanimated";

import CustomComponent from "../../../../../components/CustomComponent";
import GlobalStyles from "../../../../../globalStyles/globalStyles";
import ExperienceIcons from "../../../../../assets/Icons/ExperienceIcons";
import dimensions from "../../../../../globalStyles/dimensions";

const ExperienceCard = ({
  media,
  title,
  price,
  _id,
  averageRating,
  receiverUserInfo,
  scrollfunction,
}: {
  media: any;
  title: string;
  price: number;
  _id: string;
  averageRating: number;
  receiverUserInfo: any;
  scrollfunction?: any;
}) => {
  const navigation = useNavigation();
  // const { media, title, price, _id, averageRating, receiverUserInfo,scrollfunction} = props;
  // scrollfunction()
  // console.log(scrollfunction)
  const handleNavigation = () => {
    navigation.navigate("experience", { _id });
    setTimeout(() => {
      if (scrollfunction) {
        scrollfunction();
      }
    }, 600);
  };

  const imgUrls = [
    "https://i.pinimg.com/564x/be/63/11/be63117bef0b4dadad9fee30acdd90da.jpg",
    "https://i.pinimg.com/564x/5b/e1/58/5be1581079a41fdde2af12a9625faf68.jpg",
    "https://i.pinimg.com/564x/2b/3a/d5/2b3ad5e3c2870538a2f94a7c703add67.jpg",
    "https://i.pinimg.com/originals/9a/b7/17/9ab717681765fea86afb8dfb5287ff12.jpg",
    "https://i.pinimg.com/originals/fd/aa/44/fdaa4480ad11233caa99c8ce83f189b4.jpg",
  ];
  return (
    <Pressable onPress={handleNavigation}>
      <Animated.View entering={FadeInDown.delay(600)} style={styles.cardContainer}>
        {media && (
          <Image
            style={styles.cardImage}
            source={{
              uri:
                media?.images[0]?.url ||
                "https://i.pinimg.com/564x/be/63/11/be63117bef0b4dadad9fee30acdd90da.jpg",
            }}
            // source={{
            //   uri: imgUrls[Math.floor(Math.random() * imgUrls.length)],
            // }}
          />
        )}
        <CustomComponent.TextView
          title={title || "Brunch on the yacht"}
          textStyle={[
            GlobalStyles.title3,
            {
              fontFamily: "EBGaramondSemiBold",
              fontSize: 20,
              lineHeight: 21,
              letterSpacing: -0.3,
              color: "#313131",
            },
          ]}
          boxStyle={{ width: 150 }}
          numberoflines={2}
        />
        {/* <Text style={[GlobalStyles.captionText, { fontSize: 14 }]}>
          <Text
            style={{
              fontFamily: "InterMedium",
              letterSpacing: -0.3,
              color: "#9E9E9E",
            }}
          >
            from{" "}
          </Text>
          <Text
            style={{
              fontFamily: "EBGaramondBold",
              letterSpacing: -0.3,
              fontSize: 16,
              lineHeight: 18,
              color: "#616161",
            }}
          >{`$${price}`}</Text>
        </Text> */}
        {/* <Text style={GlobalStyles.ctaText}>
          <ExperienceIcons.StarIcon /> {averageRating} (298){" "}
          <ExperienceIcons.DotIcon /> 
          3hrs
        </Text> */}
      </Animated.View>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  cardContainer: {
    borderRadius: 8,
    width:
      Platform.OS === "ios" || Platform.OS === "android"
        ? dimensions.windowWidth / 2.28
        : dimensions.windowWidth / 2.3,
    gap: 6,
    marginTop: 10,
  },
  cardImage: {
    width: "100%",
    height: 180,
    resizeMode: "cover",
    borderRadius: 8,
    marginBottom: 0,
  },
});
2;
export default memo(ExperienceCard);
